import { Avatar as MantineAvatar, AvatarProps } from '@mantine/core';

export type IAvatarProps = AvatarProps;

/** @registry Design-layer pass-through over Mantine Avatar; import this instead of @mantine/core Avatar outside src/design. Compound statics (Avatar.Group) are preserved. */
export const Avatar = MantineAvatar;
